export const trimLeadingZeroHex = (hexString: string) => {
  if (hexString.length > 3 && hexString.startsWith('0x0')) {
    return `0x${hexString.slice(3)}`;
  }

  return hexString;
};
